import { useQuery, UseQueryOptions } from 'react-query';

import { DirectConnectMilestoneReport, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomDirectConnectMilestoneQuery(
	guid: Guid | undefined,
	options?:
		| Omit<
				UseQueryOptions<DirectConnectMilestoneReport[], unknown, DirectConnectMilestoneReport[], any>,
				'queryKey' | 'queryFn'
		  >
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Milestones.DirectConnect.Root(guid),
		() =>
			AxiosUtils.getResponseData<DirectConnectMilestoneReport[]>(
				api.get(CerebroApiEndpoints.Milestones.DirectConnect.Root(guid))
			),
		options
	);
}
